import styled from 'styled-components';

export const StationSummaryStyled = styled.div`
  .divider {
    margin: 0 -24px;

    &.warning {
      border-top: 4px solid var(--allie-color-warning-main);
    }

    &.success {
      border-top: 4px solid var(--allie-color-success-main);
    }

    &.error {
      border-top: 4px solid var(--allie-color-error-main);
    }

    &.none {
      border-top: 4px solid var(--allie-color-light-50);
    }

    &.neutral {
      border-top: 4px solid var(--allie-color-neutral-50);
    }
  }

  .container {
    display: grid;
    row-gap: 24px;

    &-po-item {
      ion-item::part(native) {
        padding: 0;
      }
    }

    &-stats {
      display: grid;
      grid-template-columns: 1fr 1fr;
      row-gap: 24px;
      column-gap: 9px;

      &__item-label {
        margin-bottom: 4px;
      }

      &__stops-pattern {
        .label {
          margin-bottom: 16px;
        }
      }

      &__health {
        grid-column: 1 / -1;
        &__label {
          margin-bottom: 8px;
        }
        &__value {
          display: flex;
          column-gap: 8px;
          align-items: center;
        }
      }
    }
  }

  .station-card {
    border-radius: 16px;
  }

  .see-detail {
    height: 100%;
    --border-width: 1px !important;
    --border-radius: 4px !important;
    --border-color: var(--allie-color-neutral-30) !important;
  }
`;
